/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes,extraRequire}
 * tslint:disable
 */
var styles = [".datePicker[_ngcontent-%COMP%]{width:350px;font-size:18px!important;font-family:Calibre}"];
export { styles as styles };

